<template>
  <header>

    <div class="container" style="padding-top: 20px">
      <div class="row justify-content-center">
        <div class="col-12 text-left">
          <img src="../assets/img/tridentLogo1.png" alt="" style="width: 15%">
        </div>
      </div>
    </div>

  </header>
</template>

<script>
export default {
  name: "MyHeader"
}
</script>

<style scoped>

</style>